"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ToggleSubject = void 0;
const rxjs_1 = require("rxjs");
/**
 * Represents a rxjs BehaviorSubject of the type boolean.
 * Additional ToggleSubject has the toggle Method to invert
 * the current value and emit the inverted value.
 * If the constructor value parameter is not specified the
 * default value is 'false'
 */
class ToggleSubject extends rxjs_1.BehaviorSubject {
    constructor(value = false) {
        super(value);
        this._onEnabledHandler = [];
        this._onDisabledHandler = [];
        this.next = this.next.bind(this);
    }
    toggle() {
        this.next(!this.value);
    }
    enable(alwaysEmit = false) {
        if (!alwaysEmit || !this.value) {
            this.next(true);
        }
    }
    disable(alwaysEmit = false) {
        if (!alwaysEmit || this.value) {
            this.next(false);
        }
    }
    next(value) {
        if (value) {
            this._onEnabledHandler.forEach(handler => handler());
        }
        else {
            this._onDisabledHandler.forEach(handler => handler());
        }
        super.next(value);
    }
    registerOnEnabled(handler) {
        this._onEnabledHandler.push(handler);
    }
    registerOnDisabled(handler) {
        this._onDisabledHandler.push(handler);
    }
}
exports.ToggleSubject = ToggleSubject;
